export default __webpack_public_path__ + "static/media/017-toy car.87572de6.svg";